export default __webpack_public_path__ + "static/media/ic_home_active.b23f692d.svg";